import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import { useDispatch } from 'react-redux'
import { playerLoad } from '../../redux/actions'
import TrackEdit from '../TrackEdit'

const Tracklist = ({ items, onClearItems, onDeleteItem, onRearrange }) => {
  const dispatch = useDispatch()

  const handleDragEnd = (result) => {
    const { destination, source } = result

    if (!destination) return

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    )
      return

    onRearrange({
      source: source.index,
      destination: destination.index,
    })
  }

  return (
    <>
      <div className="lh-copy mb3 mb2-ns mw7 w-100">
        <button
          className="bg-light-gray inter f7 fw3 bn pv1 ph2 br1 mw4 outline-0 o-100 pointer dim"
          onClick={() => onClearItems()}
          style={{ minWidth: '6rem', width: '6.75rem' }}
        >
          Clear list
        </button>
      </div>

      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable-list">
          {(provided) => (
            <ul
              className="list ma0 ph0 mb4 w-100"
              ref={provided.innerRef}
              style={{ maxWidth: '50rem' }}
              {...provided.droppableProps}
            >
              {items.map((track, index) => (
                <TrackEdit
                  key={track.url}
                  data={track}
                  i={index}
                  listId={track.list_id}
                  onDelete={() => onDeleteItem(index)}
                  play={() =>
                    dispatch(
                      playerLoad({
                        playlist: itemsToPlaylist(items),
                        index: i,
                      })
                    )
                  }
                  editMode
                />
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>
    </>
  )
}

export default Tracklist
